module.exports = __webpack_public_path__ + "img/LogoExitusMujer_Gris.7d2d4688.png";